import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailDeliveryFailed = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m12.79 12.376 4.08 4.079m-4.08 0 4.08-4.08",
		stroke: "red",
		strokeWidth: 1.35,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "m10.439 17.994-2.664-2.652-2.86 1.478.111-4.239m0 0L1.677 9.232a1.344 1.344 0 0 1-.366-1.222 1.369 1.369 0 0 1 .904-1.05l13.111-4.374a1.369 1.369 0 0 1 1.76 1.758L15 10m-9.974 2.581 11.67-9.727",
		stroke: "#A3A3A3",
		strokeWidth: 1.35,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEmailDeliveryFailed;
